// extracted by mini-css-extract-plugin
export default {"container":"point-items_container__DGhR2","title":"point-items_title__zUhHy"};